import React from "react";

const ChevronIcon = ({ open }) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{
            transition: "transform 0.25s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            display: "block",
        }}
    >
        <polyline points="6 9 12 15 18 9" />
    </svg>
);


export default React.memo(ChevronIcon);